import api from './api';

const axiosParams = {
  baseURL: 'https://transferenciasmvla.com.ar/mvlaApi/',
  //headers: {'Access-Control-Allow-Origin': '*'}
};

const URLS = {
  ordenanzas: 'Ordenanzas/',
};

export const ordenanzas = (request) => {
  let estado = request.estado != null ? request.estado : "";
  let numero = request.numero != null ? request.numero : "";
  let anio = request.anio != null ? request.anio : "";
  let pattern = request.pattern != null ? request.pattern : "";
  return api.get(URLS.ordenanzas + '?estado=' + estado +'&numero=' + numero +'&anio=' + anio +'&tag=&palabra=' + pattern, axiosParams);
};
